export default __webpack_public_path__ + "static/media/nudge.3e6987b4.svg";